import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import FloatingCalculator, { readInitialCalculatorOpen } from '@/components/FloatingCalculator';
import LoginReminderModal from '@/components/LoginReminderModal';
import { AccountingShellProvider } from '@/components/layout/AccountingShellProvider';
/**
 * همان الگوی archive / project-manager:
 * — کل ارتفاع viewport، اسکرول فقط داخل ناحیهٔ محتوا
 * — main با min-w-0 تا جدول‌ها درست کش بیایند
 * — سایدبار موبایل: overlay + کشویی از راست (RTL)
 */
const DesktopLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [calculatorOpen, setCalculatorOpen] = useState(() => readInitialCalculatorOpen());
  const [reminderOpen, setReminderOpen] = useState(true);

  return (
    <AccountingShellProvider>
      <div className="flex h-screen overflow-hidden bg-gray-100 text-gray-800" dir="rtl">
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onOpenCalculator={() => setCalculatorOpen(true)}
        />
        <main className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Header onMenuClick={() => setSidebarOpen(true)} />
          <div className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 pb-[max(3rem,env(safe-area-inset-bottom))] md:p-6">
            <div className="mx-auto w-full min-w-0 max-w-[1920px]">
              <Outlet />
            </div>
          </div>
        </main>
        <FloatingCalculator open={calculatorOpen} onOpenChange={setCalculatorOpen} />
        <LoginReminderModal open={reminderOpen} onOpenChange={setReminderOpen} />
      </div>
    </AccountingShellProvider>
  );
};

export default DesktopLayout;
